// Constantes & libellés FR pour la GMAO NGL SERVICES

export const REQUEST_TYPES = [
  { value: "urgence", label: "Urgence" },
  { value: "devis", label: "Devis" },
  { value: "intervention_programmee", label: "Intervention programmée" },
  { value: "renovation", label: "Rénovation" },
  { value: "autre", label: "Autre" },
];

export const SERVICE_TYPES = [
  { value: "vitrerie", label: "Vitrerie" },
  { value: "serrurerie", label: "Serrurerie" },
  { value: "menuiserie_exterieure", label: "Menuiserie extérieure" },
  { value: "fenetres", label: "Fenêtres" },
  { value: "portes", label: "Portes" },
  { value: "volets", label: "Volets" },
  { value: "porte_garage", label: "Porte de garage" },
  { value: "autre", label: "Autre" },
];

export const URGENCIES = [
  { value: "basse", label: "Basse" },
  { value: "normale", label: "Normale" },
  { value: "haute", label: "Haute" },
  { value: "critique", label: "Critique" },
];

// Statut : libellé + couleur (classes tailwind)
export const STATUS_META = {
  nouvelle_demande: { label: "Nouvelle demande", color: "bg-blue-100 text-blue-700 border-blue-200" },
  a_qualifier: { label: "À qualifier", color: "bg-sky-100 text-sky-700 border-sky-200" },
  devis_a_faire: { label: "Devis à faire", color: "bg-amber-100 text-amber-700 border-amber-200" },
  devis_envoye: { label: "Devis envoyé", color: "bg-amber-100 text-amber-800 border-amber-200" },
  devis_accepte: { label: "Devis accepté", color: "bg-lime-100 text-lime-700 border-lime-200" },
  intervention_programmee: { label: "Intervention programmée", color: "bg-indigo-100 text-indigo-700 border-indigo-200" },
  recue: { label: "Intervention reçue", color: "bg-slate-100 text-slate-700 border-slate-200" },
  acceptee: { label: "Acceptée", color: "bg-teal-100 text-teal-700 border-teal-200" },
  technicien_en_route: { label: "En route", color: "bg-violet-100 text-violet-700 border-violet-200" },
  arrive: { label: "Arrivé sur place", color: "bg-purple-100 text-purple-700 border-purple-200" },
  en_cours: { label: "En cours", color: "bg-cyan-100 text-cyan-700 border-cyan-200" },
  en_attente_piece: { label: "Pièce / vitrage à commander", color: "bg-orange-100 text-orange-700 border-orange-200" },
  client_absent: { label: "Client absent", color: "bg-rose-100 text-rose-700 border-rose-200" },
  impossible: { label: "Intervention impossible", color: "bg-red-100 text-red-700 border-red-200" },
  termine: { label: "Terminé", color: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  facture: { label: "Facturé", color: "bg-teal-100 text-teal-700 border-teal-200" },
  paye: { label: "Payé", color: "bg-green-100 text-green-800 border-green-200" },
  annule: { label: "Annulé", color: "bg-red-100 text-red-700 border-red-200" },
};

export const ALL_STATUSES = Object.keys(STATUS_META);

// Statuts terrain du technicien (ordre logique) + libellés courts mobile
export const TECH_STATUSES = [
  { value: "recue", label: "Reçue" },
  { value: "acceptee", label: "Acceptée" },
  { value: "technicien_en_route", label: "En route" },
  { value: "arrive", label: "Arrivé" },
  { value: "en_cours", label: "En cours" },
  { value: "en_attente_piece", label: "Pièce à commander" },
  { value: "client_absent", label: "Client absent" },
  { value: "impossible", label: "Impossible" },
  { value: "termine", label: "Terminée" },
];

export const PHOTO_CATEGORIES = [
  { value: "avant", label: "Avant" },
  { value: "pendant", label: "Pendant" },
  { value: "apres", label: "Après" },
  { value: "piece", label: "Pièce à commander" },
  { value: "securite", label: "Mise en sécurité" },
];

export const URGENCY_META = {
  basse: { label: "Basse", color: "bg-gray-100 text-gray-600" },
  normale: { label: "Normale", color: "bg-blue-100 text-blue-700" },
  haute: { label: "Haute", color: "bg-orange-100 text-orange-700" },
  critique: { label: "Critique", color: "bg-red-100 text-red-700" },
};

export const labelOf = (list, value) =>
  list.find((x) => x.value === value)?.label || value;

export const ROLE_LABELS = {
  admin: "Administrateur",
  agence: "Agence / Professionnel",
  technicien: "Technicien",
  client: "Client",
};

export const ROLE_HOME = {
  admin: "/admin",
  agence: "/gmao",
  technicien: "/technicien",
  client: "/client",
};

// URL publique de production (liens WhatsApp/partage)
export const PROD_SITE_URL = "https://www.menuisiervitrier.fr";

// Numéro FR -> format international pour wa.me
export const waPhone = (p) => {
  if (!p) return "";
  let d = String(p).replace(/[^0-9+]/g, "");
  if (d.startsWith("+")) d = d.slice(1);
  if (d.startsWith("0")) d = "33" + d.slice(1);
  return d;
};

export const waLink = (phone, text) =>
  `https://wa.me/${waPhone(phone)}?text=${encodeURIComponent(text)}`;
